import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["value", "range", "onChange", "minDate", "maxDate", "disableDates", "additionalControls", "className", "locale", "completeButtonProps", "type"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { forwardRef } from 'react';
import { cnBem } from '@carnica/utils';
import { AnimatePresence, motion } from 'framer-motion';
import { ru } from 'date-fns-new/locale';
import { withRenderFlag } from '@beef/react';
import { Button } from "../../Button";
import { MotionComponent } from "../../../modules/MotionComponent";
import { ModeToggle } from "../ModeToggle";
import styles from "./styles.pcss";
import { useCalendar } from "../hooks/useCalendar";
import { CalendarBlockDay, CalendarBlockMonth, CalendarBlockYear } from "../CalendarBlocks";
var cnCalendar = cnBem('calendar', styles);
var getCalendarBlock = function getCalendarBlock(mode, type) {
  if (mode === 'year') {
    return CalendarBlockYear;
  }
  return type === 'date' ? CalendarBlockDay : CalendarBlockMonth;
};
var Div = withRenderFlag({})(MotionComponent);
export var CalendarRender = function CalendarRender(props, ref) {
  var valueProp = props.value,
    range = props.range,
    onChange = props.onChange,
    minDate = props.minDate,
    maxDate = props.maxDate,
    disableDates = props.disableDates,
    additionalControls = props.additionalControls,
    className = props.className,
    _props$locale = props.locale,
    locale = _props$locale === void 0 ? ru : _props$locale,
    completeButtonProps = props.completeButtonProps,
    _props$type = props.type,
    type = _props$type === void 0 ? 'date' : _props$type,
    otherProps = _objectWithoutProperties(props, _excluded);
  var _useCalendar = useCalendar({
      value: valueProp,
      onChange: onChange,
      range: range,
      locale: locale
    }),
    value = _useCalendar.value,
    mode = _useCalendar.mode,
    currentVisibleDate = _useCalendar.currentVisibleDate,
    setMode = _useCalendar.setMode,
    setValue = _useCalendar.setValue,
    setCurrentVisibleDate = _useCalendar.setCurrentVisibleDate,
    onComplete = _useCalendar.onComplete;
  var blockProps = _objectSpread({
    locale: locale,
    disableDates: disableDates,
    maxDate: maxDate,
    minDate: minDate,
    onChange: setValue,
    range: range,
    value: value,
    currentVisibleDate: currentVisibleDate,
    setCurrentVisibleDate: setCurrentVisibleDate
  }, mode === 'year' ? {
    changeMode: function changeMode() {
      return setMode('date');
    }
  } : {});
  var Component = getCalendarBlock(mode, type);
  return /*#__PURE__*/React.createElement("div", _extends({}, otherProps, {
    className: cnCalendar(null, [className]),
    ref: ref,
    "data-t-id": "DatePicker-Calendar"
  }), /*#__PURE__*/React.createElement(ModeToggle, {
    className: cnCalendar('toggler'),
    date: currentVisibleDate,
    onChange: setMode,
    value: mode
  }), /*#__PURE__*/React.createElement(AnimatePresence, {
    mode: "wait"
  }, /*#__PURE__*/React.createElement(motion.div, {
    animate: {
      y: 0,
      opacity: 1
    },
    exit: {
      y: -10,
      opacity: 0.3
    },
    initial: {
      y: 10,
      opacity: 0.3
    },
    key: mode,
    transition: {
      duration: 0.2
    }
  }, /*#__PURE__*/React.createElement(Div, {
    className: cnCalendar('divider'),
    motion: true,
    shouldRender: mode === 'year' || type !== 'date'
  }), /*#__PURE__*/React.createElement(Component, blockProps), /*#__PURE__*/React.createElement(Div, {
    className: cnCalendar('controls'),
    motion: false,
    shouldRender: mode === 'date'
  }, additionalControls, /*#__PURE__*/React.createElement(Button, _extends({}, completeButtonProps || {}, {
    "aria-label": "\u041F\u0440\u0438\u043C\u0435\u043D\u0438\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F",
    className: cnCalendar('submit'),
    onClick: onComplete,
    size: "m",
    width: "full",
    "data-t-id": "DatePicker-Calendar"
  }), "\u0433\u043E\u0442\u043E\u0432\u043E")))));
};
export var Calendar = /*#__PURE__*/forwardRef(CalendarRender);